











import {
  Component,
  Inject,
  Prop,
  Vue
} from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { ApiService } from '@/services/ApiService';
import { LabelSelectionApi } from '@eurogast/hub-client-typescript';
import Store from '@/store';
import {
  Getters,
  Mutations
} from '@/store/types';
import MatomoContext from '@/matomo/domain/MatomoContext';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component
export default class LabelSelection extends Vue {
  public isLoggedIn: boolean = ConfigService.isLoggedIn();

  @Prop({required: true})
  public localProductSku: string;

  @Prop({required: false, default: 'true'})
  public localSimpleView: string;

  @Inject({default: MatomoContext.default()})
  public matomoContext: MatomoContext;

  private labelSelectionApiService = ApiService.wrap(LabelSelectionApi);

  public async toggleLabelSelection() {
    try {
      if (this.selected) {
        await this.deleteLabel();
      } else {
        await this.addLabel();
      }
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }

  private async deleteLabel() {
    MatomoEvents.forLabelToggle.removeLabel.publishWithContext(this.matomoContext);
    await this.labelSelectionApiService.deleteItemFromLabelPrint(
        ConfigService.getTenant(),
        this.localProductSku,
        ConfigService.currentCustomerId
    );
    Store.commit(Mutations.LabelSelection.removeSku, this.localProductSku);
  }

  private async addLabel() {
    MatomoEvents.forLabelToggle.addLabel.publishWithContext(this.matomoContext);
    await this.labelSelectionApiService.addItemToLabelPrint(
        ConfigService.getTenant(),
        this.localProductSku,
        ConfigService.currentCustomerId
    );
    Store.commit(Mutations.LabelSelection.addSku, this.localProductSku);
  }

  get simpleView() {
    return this.localSimpleView === 'true';
  }

  get title() {
    return this.selected ?
        this.$t('common.labelSelection.removeFromLabelPrintList') :
        this.$t('common.labelSelection.addToLabelPrintList');
  }

  get selected() {
    const skus = Store.getters[Getters.LabelSelection.getSkus];
    return skus.findIndex((item) => item.sku === this.localProductSku) !== -1;
  }
}
